import { Machine, interpret } from 'xstate';
import { IS_DEBUG } from '../utils/debug';
import initialContext from './context';
import type { UiContext } from './context';
import type { UiEvent } from './events';
import type { UiStateSchema } from './schema';
import config from './config';
import { interpreterOptions, machineOptions } from './options';

const machine = Machine<UiContext, UiStateSchema, UiEvent>(
	config,
	machineOptions,
	initialContext
);

const service = interpret(machine, interpreterOptions);

if (IS_DEBUG) {
	service.onTransition((state, event): void => {
		if (!state.changed) {
			throw new Error(
				'Undefined transition (state: ' +
					JSON.stringify(state.toStrings()) +
					'; event: ' +
					JSON.stringify(event) +
					')'
			);
		}
	});
}

service.start();

export default service;
